import { MovementReconciliationActions } from '../bancos/MovementReconciliationActions';
import { useState } from 'react';
import NumberFormat from 'react-number-format';
import { Dialog, IconButton, useMediaQuery, useTheme } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useSelector } from 'react-redux';
import moment from 'moment';

import './style/cobros.css';

import { useCobros } from '../../hooks/useCobros';
import { CobrosDialogForm } from './form/CobrosDialogForm';
import { emit } from '../../utils/eventBus';

export const CobrosDialogList = ({ dataFactura, title, openModal, setModal, checkInitialData }) => {

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm')); // móvil: sm o menor

    const { listaCtasBancarias } = useSelector(state => state.general)
    const { detailCobro, initGetCobrosByFactura, initGetOneCobro, initDeleteCobro } = useCobros()
    const [openCobrosDialogForm, setOpenCobrosDialogForm] = useState(false)
    const { id: facturaId, cobros } = dataFactura

    const handleDelete = async (cobroId) => {
        const deleted = await initDeleteCobro(cobroId);
        if (!deleted) return false;
        await initGetCobrosByFactura(facturaId)
        if (typeof checkInitialData === 'function') await checkInitialData(facturaId)

        emit("flows_updated");

        if (cobros?.length === 0) {
            setModal(false)
        }

        return true;
    }

    const handleEdit = async (cobroId) => {
        await initGetOneCobro(cobroId)
        setOpenCobrosDialogForm(true)
    }

    return (
        <>

            {openCobrosDialogForm &&
                <CobrosDialogForm
                    initialData={detailCobro}
                    title='Cobro emitido'
                    openModal={openCobrosDialogForm}
                    setModal={setOpenCobrosDialogForm}
                    dataFactura={dataFactura}
                    checkInitialData={checkInitialData}
                />
            }

            <Dialog
                className='dialogModalList'
                open={openModal}
                onClose={() => setModal(false)}
                aria-labelledby="simple-dialog-title"
                fullScreen={isMobile}
                PaperProps={{
                    className: isMobile ? '' : (cobros.length > 0 ? 'min-w-[80%]' : 'w-100')
                }}
            >
                <div className='ContainerDialogs'>
                    <h1 className='title-lista-pagos'>
                        {title}
                        <IconButton
                            style={{ padding: '0', float: 'right' }}
                            aria-label="close"
                            onClick={() => setModal(false)}
                        >
                            <CloseIcon />
                        </IconButton>
                    </h1>

                    <div className="table-responsive">
                        <table className="table p-table-global lista-pagos">
                            <thead className='p-thead-global'>
                                <tr className="text-center p-tr-titles-global">
                                    <th scope="col" className='text-start'>Cliente</th>
                                    <th scope="col">Fecha</th>
                                    <th scope="col">Tipo</th>
                                    <th scope="col" className='text-start'>Cta. Bancaria</th>
                                    <th scope="col">Nro. de operación</th>
                                    <th scope="col" className='text-end'>Total</th>
                                    <th scope="col" className='text-end'>Link</th>
                                    <th scope="col">Conciliación / acciones</th>
                                </tr>
                            </thead>
                            <tbody>
                                {cobros?.map(item => (
                                    <tr className="text-center p-tr-body-global" key={item.id}>
                                        <td className='text-start'>{item.cliente || 'Ninguno'}</td>
                                        <td>{moment(item.fecha_cobro).format('DD-MM-YYYY') || 'Ninguno'}</td>
                                        <td>{item.tipo_cobro_nombre || 'Ninguno'}</td>
                                        {/* <td className='text-start'>{item.nombre_cta_bancaria || 'Ninguno'}</td> */}
                                        <td className='text-start'>
                                            {listaCtasBancarias?.find(c => parseInt(c.id) === parseInt(item.id_cta_bancaria))?.nombre || 'Ninguno'}
                                        </td>
                                        <td>{item.nro_operacion || 'Ninguno'}</td>
                                        <td className='text-end'>
                                            <NumberFormat
                                                value={item.total_cobro}
                                                displayType={'text'}
                                                thousandSeparator={item.separacion_miles}
                                                decimalSeparator={item.separacion_decimales}
                                                decimalScale={2}
                                                prefix={`${item.simbolo} `}
                                                fixedDecimalScale
                                            />
                                        </td>
                                        <td>
                                            {(item?.url_boucher !== null && item?.url_boucher !== '') ?
                                                <a
                                                    className='p-links'
                                                    href={item?.url_boucher || ''}
                                                    target="_blank"
                                                    rel="noreferrer"
                                                >
                                                    Ver boucher
                                                </a>
                                                :
                                                <span style={{ textTransform: 'none' }}>---</span>
                                            }
                                        </td>
                                        <td>
                                            <MovementReconciliationActions movement={item} type="ingreso" onEdit={() => handleEdit(item.id)} onDelete={() => handleDelete(item.id)}
                                                onChanged={async () => { await initGetCobrosByFactura(facturaId); if (typeof checkInitialData === 'function') await checkInitialData(facturaId); }} />
                                        </td>
                                    </tr>
                                ))
                                }
                            </tbody>
                        </table>
                    </div>

                </div>
            </Dialog>
        </>
    )
}
